import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  GuardResult,
  MaybeAsync,
  RedirectCommand,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { combineLatest, map } from 'rxjs';

import { AuthService } from '@core/auth-service/auth.service';
import { ResponsiveService } from '@core/responsive.service';

import { START_PAGE } from './pages';

@Injectable({
  providedIn: 'root',
})
export class DefaultPageGuard implements CanActivate {
  private authService = inject(AuthService);
  private router = inject(Router);
  private responsiveService = inject(ResponsiveService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
    // why return a UrlTree https://juristr.com/blog/2018/11/better-route-guard-redirects/
    return combineLatest([
      this.authService.loggedInUser$,
      this.responsiveService.isMobilePortrait$,
    ]).pipe(
      map(([user, isMobile]) => {
        if (!user) {
          return false;
        }

        if (isMobile) {
          return this.redirectTo('orders');
        }

        if (this.router.currentNavigation()?.extras.state?.fromDefaultPageGuard) {
          console.warn('prevented redirect loop for user start page ' + user.startPage);
          return this.redirectTo('/');
        }

        if (user.startPage) {
          const startPage = this.mapStartPage(user.startPage);
          return this.redirectTo(startPage);
        }
        return this.redirectTo('/');
      }),
    );
  }

  private redirectTo(url: string): RedirectCommand {
    const urlTree = this.router.parseUrl(url);
    return new RedirectCommand(urlTree, {
      state: { fromDefaultPageGuard: true },
    });
  }

  private mapStartPage(startPage: string) {
    switch (startPage) {
      case START_PAGE.ORDERS:
        return 'orders/overview/orders';
      case START_PAGE.SAMPLE:
        return 'orders/overview/samples';
      case START_PAGE.SAMPLE_STORAGE:
        return 'orders/overview/sampleStorage';
      case START_PAGE.BILLS:
        return 'orders/overview/invoices';
      case START_PAGE.TEMPLATE:
        return 'orders/overview/templates';
      case START_PAGE.HOME:
        return '/';
      default:
        return startPage;
    }
  }
}
